"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Ghost = exports.Basic = void 0;

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var _core = require("@material-ui/core");

var _icons = require("@material-ui/icons");

var Icons = _interopRequireWildcard(require("@zip/react-icons/fearless"));

var _react = require("react");

var TextFields = _interopRequireWildcard(require("../textfield/TextField"));

var style = _interopRequireWildcard(require("./Select.styles"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Basic = function Basic(_ref) {
  var onChange = _ref.onChange,
      options = _ref.options,
      value = _ref.value,
      _ref$fullWidth = _ref.fullWidth,
      fullWidth = _ref$fullWidth === void 0 ? false : _ref$fullWidth,
      props = _objectWithoutProperties(_ref, ["onChange", "options", "value", "fullWidth"]);

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      isActive = _useState2[0],
      setIsActive = _useState2[1];

  return (0, _jsxRuntime.jsx)(TextFields.Basic, _objectSpread(_objectSpread({
    SelectProps: {
      IconComponent: _icons.KeyboardArrowDown,
      MenuProps: {
        getContentAnchorEl: null,
        anchorOrigin: {
          vertical: 'bottom',
          horizontal: 'left'
        },
        MenuListProps: {
          disablePadding: true,
          style: {
            maxWidth: 320
          }
        }
      },
      value: value,
      onOpen: function onOpen() {
        return setIsActive(true);
      },
      onClose: function onClose() {
        return setIsActive(false);
      }
    },
    onChange: onChange,
    select: true,
    css: style.basic(fullWidth, isActive),
    fullWidth: fullWidth
  }, props), {}, {
    children: options.map(function (option) {
      return (0, _jsxRuntime.jsxs)(_core.MenuItem, {
        value: option.value,
        css: style.menuItem(value === option.value),
        children: [option.label, (0, _jsxRuntime.jsx)(Icons.Check, {
          css: style.icon
        })]
      }, option.value);
    })
  }));
};

exports.Basic = Basic;

var Ghost = function Ghost(_ref2) {
  var onChange = _ref2.onChange,
      options = _ref2.options,
      value = _ref2.value,
      _ref2$fullWidth = _ref2.fullWidth,
      fullWidth = _ref2$fullWidth === void 0 ? false : _ref2$fullWidth,
      props = _objectWithoutProperties(_ref2, ["onChange", "options", "value", "fullWidth"]);

  var _useState3 = (0, _react.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isActive = _useState4[0],
      setIsActive = _useState4[1];

  return (0, _jsxRuntime.jsx)(TextFields.Basic, _objectSpread(_objectSpread({
    SelectProps: {
      IconComponent: _icons.KeyboardArrowDown,
      MenuProps: {
        getContentAnchorEl: null,
        anchorOrigin: {
          vertical: 'bottom',
          horizontal: 'left'
        },
        MenuListProps: {
          disablePadding: true,
          style: {
            maxWidth: 320
          }
        }
      },
      value: value,
      onOpen: function onOpen() {
        return setIsActive(true);
      },
      onClose: function onClose() {
        return setIsActive(false);
      }
    },
    onChange: onChange,
    select: true,
    css: style.ghost(fullWidth, isActive),
    fullWidth: fullWidth
  }, props), {}, {
    children: options.map(function (option) {
      return (0, _jsxRuntime.jsxs)(_core.MenuItem, {
        value: option.value,
        css: style.menuItem(value === option.value),
        children: [option.label, (0, _jsxRuntime.jsx)(Icons.Check, {
          css: style.icon
        })]
      }, option.value);
    })
  }));
};

exports.Ghost = Ghost;